// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_3E4ih","itemPic":"index_itemPic_1uQMk"};